import React from "react";
import ReservationsView from "./components/ReservationsView";
import OrdersView from "./components/OrdersView";
import CalendarView from "./components/CalendarView";
import { isViewVisible } from "../../../utils/ViewSettings";
import Rbac from "../../../utils/Rbac";
export const rbac = new Rbac({
  _rbac: {
    admin: {
      editStatus: true,
      edit: true,
      log: true,
    },
    manager: {
      editStatus: true,
      edit: true,
      log: true,
    },
    "booking-manager": {
      editStatus: true,
      edit: true,
      log: true,
    },
    "manager-location": {
      editStatus: true,
      edit: true,
      log: true,
    },
    user: {
      editStatus: false,
      edit: false,
    },
    "garage-staff": {
      editStatus: true,
      edit: true,
    },
    mediator: {
      editStatus: true,
      edit: true,
    },
    guide: {
      editStatus: true,
      edit: true,
    },
  },
});

export const ReservationsPage = (props) => {
  var _view = typeof props.view === "undefined" || props.view === null ? "index" : props.view;
  var indexView = isViewVisible("reservations", "reservations")
    ? "reservations"
    : isViewVisible("orders", "reservations")
      ? "orders"
      : isViewVisible("calendar", "reservations")
        ? "calendar"
        : null;

  return (
    <>
      {(_view === "reservations" || (_view === "index" && indexView === "reservations")) && (
        <ReservationsView
          name={"reservations"}
          dispatch={props.dispatch}
          params={props.params}
          states={props.states}
        />
      )}
      {(_view === "orders" || (_view === "index" && indexView === "orders")) && (
        <OrdersView
          name={"orders"}
          dispatch={props.dispatch}
          params={props.params}
          states={props.states}
        />
      )}
      {(_view === "calendar" || (_view === "index" && indexView === "calendar")) && (
        <CalendarView
          name={"calendar"}
          dispatch={props.dispatch}
          params={props.params}
          states={props.states}
        />
      )}
    </>
  );
};
